module.exports = __webpack_public_path__ + "static/media/insure.52b85a50.svg";